import { SerializedData, Store } from 'bernie-core';
import { action, observable } from 'mobx';
import { PzOAuthSource } from '../sources/pz-oauth-source';
import AffiliateHubLogger from '../util/affiliate-hub-logger';
import { Logger } from 'bernie-logger';

export enum FetchStatus {
  FETCH_NOT_INITIALIZED,
  FETCHING,
  FAILED,
  SUCCESS,
}

export class PzOAuthStore extends Store {
  @observable
  private accessToken: string;

  @observable
  private fetchStatus: FetchStatus;

  private responseCode: string;

  private responseMessage: string;

  private pzAuthSource: PzOAuthSource;

  public constructor(pzAuthSource: PzOAuthSource, state: SerializedData, logger: Logger) {
    super(state, logger);
    this.pzAuthSource = pzAuthSource;
    this.fetchStatus = FetchStatus.FETCH_NOT_INITIALIZED;
  }

  public hydrate(data: SerializedData): void {
    // Not required
  }

  @action
  public async fetchAccessToken(authorizationCode: string) {
    try {
      this.fetchStatus = FetchStatus.FETCHING;
      const response = await this.pzAuthSource.getAccessToken(authorizationCode);
      this.accessToken = response?.body;
      this.fetchStatus = FetchStatus.SUCCESS;
    } catch (e) {
      // Source has done all the handling for us, at this point, we should be quite sure that errorCode and body should
      // be present in the exception thrown.
      this.fetchStatus = FetchStatus.FAILED;
      this.responseCode = e.errorCode;
      this.responseMessage = e.body;

      this.getLogger().error('PZ_ACCESS_TOKEN_FETCH_FAILED', e);

      return Promise.reject(e);
    }

    return Promise.resolve(this.accessToken);
  }

  private getLogger(): AffiliateHubLogger {
    return this.logger as AffiliateHubLogger;
  }

  public getFetchStatus() {
    return this.fetchStatus;
  }

  public setSource(source: PzOAuthSource) {
    this.pzAuthSource = source;
  }

  public getAccessToken() {
    return this.accessToken;
  }

  public getResponseCode() {
    return this.responseCode;
  }

  public getResponseMessage() {
    return this.responseMessage;
  }
}
